import React, { useEffect, useState } from "react";
import {
  GET_FILTERS_INFO_MENTIONFORORDER,
  GET_SELLER_ORDER_PRODUCT_NAME_LIST,
  GET_SELLER_ORDER_SKU_LIST,
} from "../../../../utils/ApiUrls";
import CustomAccordian from "./filterAccordian";
import { POST } from "../../../../utils/webService";
import { Spinner } from "../../../../components/Spinner";
import { keyNameMapping } from "../../../../utils/dummyData";
import { capitalizeFirstLetter } from "../../../../utils/utility";
import PincodeFilterAccordian from "./pincodeFilterAccordian";
import RemoteSearchFilterAccordian from "./remoteSearchFilterAccordian";
import Checkbox from "../../../../components/CheckBox/index2";
import downArrowIcon from "../../../../assets/Filter/downArrow.svg";

const SORT_BY_ORDER_ID_OPTIONS: { label: string; value: "asc" | "desc" }[] = [
  { label: "Ascending", value: "asc" },
  { label: "Descending", value: "desc" },
];

function FilterScreen({
  filterState,
  setFilterState,
  setFilterPayLoad,
  filterPayLoad,
  filterModal,
  setPersistFilterData,
  persistFilterData,
  currentStatus,
  sortByOrderId,
  setSortByOrderId,
}: any) {
  const [filterOptionList, setFilterOptionList] = useState([]);
  const [isLoading, setIsLoading] = useState<any>(false);
  const [isSearchLoading, setIsSearchLoading] = useState([
    { name: "deliveryPincode", isLoading: false },
    { name: "pickupPincode", isLoading: false },
  ]);
  const [searchPincodListLoader, setSearchPincodListLoader]: any = useState([
    {
      label: "deliveryPincode",
      name: "Delivery Pincode",
      menu: [],
      isCollapse: false,
    },
    {
      label: "pickupPincode",
      name: "Pickup Pincode",
      menu: [],
      isCollapse: false,
    },
  ]);
  const remoteSearchFilterList = [
    {
      label: "sku",
      name: "SKU",
      menu: [],
      isCollapse: false,
      apiUrl: GET_SELLER_ORDER_SKU_LIST,
      filterKey: "boxInfo.products.sku",
    },
    {
      label: "productName",
      name: "Product Name",
      menu: [],
      isCollapse: false,
      apiUrl: GET_SELLER_ORDER_PRODUCT_NAME_LIST,
      filterKey: "boxInfo.products.name",
    },
  ];
  const [isSortByOrderIdCollapse, setIsSortByOrderIdCollapse] =
    useState(false);
  const [dateRange, setDateRange]: any = useState([new Date(), new Date()]);
  const [startDate, endDate] = dateRange;

  const reportEndDate = new Date();

  const isDateDisabled = (date: any) => {
    return date <= reportEndDate;
  };

  const convertEpoch = (epochDate: any) => {
    return epochDate?.getTime() || "";
  };

  const sourcesObj: any = {
    Zoho: "Cart - Zoho",
    Shopify: "Cart - Shopify",
    Woocommerce: "Cart - Woocommerce",
    Bulk_b2c: "Sy - Bulk B2B",
    Bulk_b2b: "Sy - Bulk B2C",
    Website: "Sy - Single Order",
    Api: "Sy - Api",
  };

  const sourcesArr = [
    "Zoho",
    "Shopify",
    "Woocommerce",
    "Bulk_b2c",
    "Bulk_b2b",
    "Website",
    "Api",
  ];

  const getFilterDropDownData = async () => {
    setIsLoading(true);
    const { data } = await POST(GET_FILTERS_INFO_MENTIONFORORDER, {});
    if (data?.success) {
      const result: any = [];

      for (const [key, name] of Object.entries(keyNameMapping)) {
        let menu: any = [];

        if (key === "store") {
          const storeList: any[] = data?.data?.[0][key] || [];

          menu = storeList.map((storeObj: any) => {
            const storeName = storeObj?.storeName || "";
            const storeIds: string[] = storeObj?.storeIds || [];

            return {
              name: storeName,
              value: storeIds, 
              isActive:
                Object.keys(persistFilterData).length > 0
                  ? storeIds.some((id) => persistFilterData[key]?.includes(id))
                  : false,
            };
          });
        } else {
          let values: any = data?.data?.[0][key]?.map(
            (obj: any) => Object.values(obj)[0]
          );

          values = values?.map((item: any) => {
            return item;
          });

          menu = values?.map((value: any) => {
            return {
              name: sourcesArr.includes(capitalizeFirstLetter(value))
                ? sourcesObj[capitalizeFirstLetter(value)]
                : value,
              value: value,
              isActive:
                Object.keys(persistFilterData).length > 0
                  ? ["deliveryPincode", "pickupPincode", "sellerId"]?.includes(
                      key
                    )
                    ? persistFilterData[key]?.includes(+value)
                    : persistFilterData[key]?.includes(value)
                  : false,
            };
          });
        }

        menu = menu.sort((a: any, b: any) => a.name.localeCompare(b.name));

        if (key === "store" && (!menu || menu.length === 0)) {
          continue;
        }

        const currentObject = {
          name: name?.name,
          label: name?.label,
          isCollapse: false,
          menu: menu,
        };
        result.push(currentObject);
      }
      setFilterOptionList(result);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getFilterDropDownData();
  }, []);

  return (
    <div className="my-4">
      <div className="flex flex-col mb-5 shadow-sm rounded-xl cursor-pointer">
        <div
          className={`flex items-center justify-between gap-3 px-3 py-3 border border-gray-200 ${
            isSortByOrderIdCollapse
              ? "bg-[#f6f6f6] rounded-t-xl rounded-b-none"
              : "bg-white rounded-xl"
          }`}
          onClick={() => setIsSortByOrderIdCollapse(!isSortByOrderIdCollapse)}
        >
          <p className="font-semibold flex-1 text-[14px] text-[#1C1C1C] leading-tight">
            Sort By Order ID
          </p>
          <div
            className={`flex ${
              isSortByOrderIdCollapse && "border shadow-md"
            } rounded-lg`}
          >
            <div
              className={`flex items-center rounded-l-lg ${
                isSortByOrderIdCollapse ? "bg-[#F6F6F6]" : "bg-white"
              }`}
            />
            <div className="flex py-2 px-3 border-l rounded-r hover:bg-[#F6F6F6] bg-white">
              <img
                src={downArrowIcon}
                alt="downArrowIcon"
                className={`transform w-[18px] transition-transform duration-400 ${
                  isSortByOrderIdCollapse ? "rotate-180" : ""
                }`}
              />
            </div>
          </div>
        </div>
        {isSortByOrderIdCollapse && (
          <div className="border-b border-r border-l border-gray-200 py-0 rounded-b-xl bg-white">
            {SORT_BY_ORDER_ID_OPTIONS.map((option, index) => (
              <div className="px-2" key={option.value}>
                <button
                  type="button"
                  className={`flex items-center cursor-pointer w-full border py-4 gap-3 h-[28px] ${
                    index !== SORT_BY_ORDER_ID_OPTIONS.length - 1
                      ? "border-b-[#E8E8E8]"
                      : "border-t-0"
                  } border-t-0 border-r-0 border-l-0`}
                  onClick={() =>
                    setSortByOrderId(
                      sortByOrderId === option.value ? "" : option.value
                    )
                  }
                >
                  <Checkbox
                    className="px-4"
                    checkboxClassName="gap-1"
                    name="sortByOrderId"
                    checked={sortByOrderId === option.value}
                  />
                  <p className="font-semibold text-[13px] text-[#323232] break-words">
                    {option.label}
                  </p>
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="flex flex-col gap-y-5">
        {searchPincodListLoader.map((pincodeData: any, i: any) => {
          return (
            <PincodeFilterAccordian
              data={pincodeData}
              persistFilterData={persistFilterData}
              setFilterState={setFilterState}
              filterPayLoad={filterPayLoad}
              setFilterPayLoad={setFilterPayLoad}
              setPersistFilterData={setPersistFilterData}
              key={`${i}_${pincodeData.name}`}
            />
          );
        })}
        {remoteSearchFilterList.map((filterData: any, i: number) => {
          return (
            <RemoteSearchFilterAccordian
              data={filterData}
              currentStatus={currentStatus}
              filterModal={filterModal}
              persistFilterData={persistFilterData}
              setPersistFilterData={setPersistFilterData}
              setFilterPayLoad={setFilterPayLoad}
              key={`${i}_${filterData.name}`}
            />
          );
        })}
      </div>
      <div className="mt-3">
        {isLoading ? (
          <div className="flex justify-center items-center h-[600px]">
            <Spinner />
          </div>
        ) : (
          <>
            {/* <DatePicker
            selectsRange={true}
            startDate={startDate}
            endDate={endDate}
            onChange={(update: any) => {
              setDateRange(update);
            }}
            filterDate={isDateDisabled}
            isClearable={true}
            placeholderText="Select From & To Date"
            className="cursor-pointer border-solid border-2 datepickerCss border-sky-500 pl-6"
            dateFormat="dd/MM/yyyy"
          /> */}

            {filterOptionList &&
              filterOptionList.map((singleAccordianDataList: any, i: any) => (
                <CustomAccordian
                  key={`${i}_${singleAccordianDataList?.name}`}
                  cardClassName="lg:!px-0 lg:!mt-4"
                  filterListDatas={singleAccordianDataList}
                  isLoading={isLoading}
                  setFilterState={setFilterState}
                  filterState={filterState}
                />
              ))}
          </>
        )}
      </div>
    </div>
  );
}

export default FilterScreen;
